export default __webpack_public_path__ + "static/media/img4.cfc84e96.jpg";